import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BusinessUser, BusinessUserRole } from '@models/businesses';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import { BusinessUsersState } from '@state/business-users/business-users.state';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DropdownResult } from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';

@UntilDestroy()
@Component({
	selector: 'app-business-user-filter',
	templateUrl: './business-user-filter.component.html',
	standalone: false,
})
export class BusinessUserFilterComponent {
	@Select(BusinessUsersState.getActiveUsers) all$: Observable<BusinessUser[]>;

	@Input() label: string;
	@Output() selected: EventEmitter<BusinessUser> =
		new EventEmitter<BusinessUser>();

	list: BusinessUser[];
	selectedDropDownValue;
	placeholder;

	@Input() set filterBy(filterBy: 'ALL' | 'LAWYER' | 'CLERK') {
		switch (filterBy) {
			case 'ALL':
				this.placeholder = 'Select User';
				break;
			case 'LAWYER':
				this.placeholder = 'Select Lawyer';
				break;
			case 'CLERK':
				this.placeholder = 'Select Clerk';
				break;
		}

		this.all$
			.pipe(
				untilDestroyed(this),
				map((x) =>
					x.filter((item) => {
						switch (filterBy) {
							case 'ALL':
								return true;
							case 'LAWYER':
								return item.role === BusinessUserRole.LAWYER;
							case 'CLERK':
								return item.role === BusinessUserRole.CLERK;
							default:
								return false;
						}
					}),
				),
			)
			.subscribe((value: BusinessUser[]) => {
				this.list = value;
			});
	}

	onSelect($event: DropdownResult<BusinessUser>) {
		if ($event.group === 0) {
			this.selectedDropDownValue = null;
			this.selected.emit(null);
		} else {
			this.selectedDropDownValue = `${$event.result.firstName} ${$event.result.lastName}`;
			this.selected.emit($event.result);
		}
	}

	reset() {
		this.selectedDropDownValue = null;
	}
}
